import React from 'react'

import {Button, Col, Divider, Spin, Typography} from 'antd'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import {getArtistContractTemplate} from "../../api/artistContractTemplates";
import HttpError from "../../component/base/HttpError";
import {getPageId} from "../../component/Utils";
import {ArrowLeftOutlined, DownloadOutlined} from "@ant-design/icons";
import FormButton from "../../component/base/FormButton";

const {Title} = Typography

@connect((state) => ({
    //decorator, gives component access to the state
    userId: state.user.info.id,
    email: state.user.info.email,
    role: state.user.info.role
}))
class TemplateDetail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            template: null,
            loading: false,
        }
    }

    getTemplateId = () => {
        return getPageId(this.props)
    }

    componentDidMount() {
        this.setState({loading: true})
        getArtistContractTemplate(this.getTemplateId()).then((res) => {
            this.setState({template: res.data})
        }).catch((error) => {
            HttpError(error)
        }).finally(() => {
            this.setState({loading: false})
        })
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <div style={{display: 'flex'}}>
                    <Title>{this.state.template?.title}
                    </Title>
                    {this.state.template && (
                        <Button type={'primary'} target={'_blank'} icon={<DownloadOutlined/>}
                                style={{marginLeft: 'auto'}}
                                onClick={() => {
                                    window.open(this.state.template?.url, '_blank')
                                }}>Download</Button>
                    )}
                </div>
                <Divider orientation='left'/>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <div style={{padding: '3vw', maxWidth: 1200, marginLeft: 'auto', marginRight: 'auto'}}>
                        <div dangerouslySetInnerHTML={{__html: this.state.template?.body}}/>
                    </div>
                </div>
                <FormButton>

                    <Col
                        xs={24}
                        style={{
                            display: 'flex',
                            width: '100%',
                        }}
                    >
                        <div style={{marginLeft: '6%', marginRight: 'auto', display: 'flex'}}>
                            <div>
                                <Button block size='large' onClick={this.props.history?.goBack}>
                                    <ArrowLeftOutlined/>
                                    <span style={{fontSize: 14}}>Back</span>
                                </Button>
                            </div>

                        </div>
                    </Col>
                </FormButton>
            </Spin>
        )
    }
}

export default withRouter(TemplateDetail)
